export const media = {
  purchase: {
    imageTitle: "購入して閲覧しますか？",
    videoTitle: "購入して再生しますか？",
    imageDescription: "ポイントを消費して画像を閲覧します。",
    videoDescription: "ポイントを消費して動画を再生します。",
    audioTitle: "購入して再生しますか？",
    audioDescription: "ポイントを消費して音声を再生します。",
    point: (args: { point: string | number }) => `${args.point}pt`,
    confirm: "購入する",
  },
  profileList: {
    title: "画像・動画一覧",
    moreCount: (args: { count: string | number }) => `+${args.count}`,
    imageItemLabel: "画像",
    videoItemLabel: "動画",
    requestLabel: "画像・動画リクエスト",
    requestModal: {
      title: "画像・動画をリクエスト",
      imageButton: "画像をリクエスト",
      videoButton: "動画をリクエスト",
    },
    requestSentImage: "画像リクエストを送信しました",
    requestSentVideo: "動画リクエストを送信しました",
    requestCooldown: "同じ人に連続でリクエストはできません。",
  },
} as const;
